import { useState, useEffect } from "react";
import useUser from "./useUser";

const useUserProfile = () => {
  const { data: userData, isLoading: isUserLoading } = useUser();

  const [isDataEntrySupervisor, setIsDataEntrySupervisor] = useState(null);
  const [isAdmin, setIsAdmin] = useState(null);
  const [isAdminVistaflow, setIsAdminVistaflow] = useState(null);
  const [isDataReadOnlyOperators, setIsDataReadOnlyOperators] = useState(null);

  useEffect(() => {
    if (userData) {
      setIsDataEntrySupervisor(
        userData.user_group?.split(",").includes("DataEntrySupervisors"),
      );
      setIsAdmin(userData.user_group?.split(",").includes("Admins"));
      setIsAdminVistaflow(userData.user_group?.split(",").includes("AdminsVistaflow"));
      setIsDataReadOnlyOperators(
        userData.user_group?.split(",").includes("DataReadOnlyOperators"),
      );
    }
  }, [userData]);

  return {
    isDataReadOnlyOperators,
    isDataEntrySupervisor,
    isAdmin,
    isAdminVistaflow,
    isUserLoading,
  };
};

export default useUserProfile;
